import { SelectField, SelectFieldSingleValidation } from 'payload'
import { text } from 'payload/shared'
import { FieldDefault, FieldWithouType } from '@utils/fields'
import { mergeObjects } from '@utils/objects'
import { SelectAjaxOptions } from '@components/(payload)/fields/select/ajax';

/**
 * Creates a Select Field with Ajax
 *
 * @param config
 * @returns
 */
export function selectAjaxField(config: WithRequired<Partial<CustomPayloadField<SelectField>>, 'name'>, options: SelectAjaxOptions | string): CustomPayloadField<SelectField>[] {
  const configDefault: FieldDefault<CustomPayloadField<SelectField>> = {
    type: 'select',
    options: [],
    admin: {
      components: {
        Field: {
          path: '@components/(payload)/fields/select/ajax',
          clientProps: typeof options === 'string' ? { endpoint: options } : options,
        }
      }
    },
    validate: (async (value, ctx) => {
      if (! config.required) {
        return true;
      }

      return Boolean(value) || ctx.req.t('validation:required');
    }) as SelectFieldSingleValidation
  };

  const field: CustomPayloadField<SelectField> = mergeObjects(config, configDefault);
  return [ field ];
}
